import axios from "axios";

const ApiClient = axios.create();
let cancelTokenSource = axios.CancelToken.source();

ApiClient.interceptors.request.use(
  (config) => {
    config.baseURL = process.env.REACT_APP_BACKEND_URL;
    config.cancelToken = cancelTokenSource.token;

    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    console.error("Request interceptor error:", error);
    return Promise.reject(error);
  },
);

ApiClient.interceptors.response.use(
  (res) => {
    return res;
  },
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.clear();
      cancelTokenSource.cancel("401 Unauthorized detected. Cancelling all requests.");
      // window.location.href = "/";
      // cancel token reset after 401 status code
      cancelTokenSource = axios.CancelToken.source();
    }
    return Promise.reject(err);
  },
);

export default ApiClient;
